import React from 'react';
import styled from 'styled-components';

const FooterContainer = styled.footer`
  background: rgba(0, 0, 0, 0.9);
  color: white;
  padding: 2rem 0;
  margin-top: auto;
`;

const FooterContent = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 2rem;
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 2rem;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
    text-align: center;
  }
`;

const FooterSection = styled.div`
  h3 {
    margin-bottom: 1rem;
    color: #efb348;
    font-size: 1.1rem;
  }

  p,
  a {
    margin-bottom: 0.5rem;
    color: rgba(255, 255, 255, 0.8);
    line-height: 1.6;
    text-decoration: none;
  }

  a:hover {
    color: #efb348;
  }
`;

const Copyright = styled.div`
  text-align: center;
  padding-top: 2rem;
  border-top: 1px solid rgba(255, 255, 255, 0.1);
  color: rgba(255, 255, 255, 0.6);
  font-size: 0.9rem;
`;

const Footer = () => {
  let year = new Date();
  return (
    <FooterContainer>
      <FooterContent>
        <FooterSection>
          <h3>TUnion 价值联盟</h3>
          <p>
            SGX(Sydgoldx Pty Ltd) 悉尼黄金交易所，澳洲注册持牌金融科技机构，
            世界领先的多币种稳定通证交易平台。
          </p>
          <p>ABN: 81 642 600 600</p>
          <p>AAN: 100740261</p>
        </FooterSection>

        <FooterSection>
          <h3>联系信息</h3>
          <p>📧 support@sydgoldx.com.au</p>
          <p>📍 悉尼中央商务区金融核心区</p>
          <p>🏢 澳大利亚悉尼</p>
        </FooterSection>

        <FooterSection>
          <h3>监管信息</h3>
          <p>✅ AUSTRAC注册监管</p>
          <p>✅ 专注于多币种稳定通证</p>
          <p>✅ 合规安全交易平台</p>
        </FooterSection>
      </FooterContent>

      <Copyright>
        <p>
          &copy; {year.getFullYear()} TUnion (SGX). All rights reserved. |
          稳定通证交易联盟 版权所有
        </p>
      </Copyright>
    </FooterContainer>
  );
};

export default Footer;
